// Copyright (c) StrangeBee 2024

import RouteBuilder from '@Services/RouteBuilder';
import { RouteType } from '@Types';
import { PermissionsEnum } from 'thehive-sdk';
import { ICONS } from '@Constants/iconsApp';
import { MailerDetails } from './MailerDetails';

const path = RouteBuilder.compute('administration.mailer');
export const Route: RouteType = {
    path,
    menu: {
        label: 'mainLayout.adminMenu.mailer',
        icon: <ICONS.InboxOutlined />,
    },
    breadcrumb: { label: 'breadcrumb.global.mailer' },
    content: <MailerDetails />,
    permissionNeeded: [PermissionsEnum.MANAGE_CONFIG],

    space: ['admin'],
    exact: true,
};
